import {BaseIdentityCardNumberValidator} from './validator';

export {IdentityCardNumberDirective} from './directive';
export {IdentityCardNumberPipe} from './pipe';

export const IDENTITY_CARD_NUMBER_VALIDATORS = [BaseIdentityCardNumberValidator];
